import React, { useState } from 'react';
import {
  auth,
  db,
  doc,
  setDoc,
  getDoc,
  serverTimestamp,
  signInWithEmailAndPassword,
  sendPasswordResetEmail
} from '../../firebase';
import TermsOfService from '../TermsOfService';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Check if user profile exists in Firestore, create if not (migration)
      const userDocRef = doc(db, 'users', user.uid);
      const userSnap = await getDoc(userDocRef);

      if (!userSnap.exists()) {
        // Migrate from old system - create Firestore profile
        await setDoc(userDocRef, {
          email: user.email,
          name: user.email.split('@')[0],
          createdAt: serverTimestamp()
        });
      }

      onLogin(user);
    } catch (err) {
      setError(err.message.replace('Firebase: ', ''));
    }

    setLoading(false);
  };

  const handleForgotPassword = async () => {
    if (!email.trim()) {
      setError('Please enter your email address first');
      return;
    }

    setResetLoading(true);
    setError('');
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
    } catch (err) {
      setError(err.message.replace('Firebase: ', ''));
    }
    setResetLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1 className="auth-title">TempSensor</h1>
        <h2>Sign In</h2>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              required
            />
          </div>

          <div className="auth-field">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
            />
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Please wait...' : 'Sign In'}
          </button>
        </form>

        {resetSent ? (
          <p className="auth-success">
            Password reset email sent! Check your inbox.
          </p>
        ) : (
          <button
            className="auth-forgot"
            onClick={handleForgotPassword}
            disabled={resetLoading}
            type="button"
          >
            {resetLoading ? 'Sending...' : 'Forgot Password?'}
          </button>
        )}

        <p className="auth-hint">
          Contact your administrator for access.
        </p>

        <p className="auth-terms">
          By signing in you agree to our{' '}
          <button className="auth-terms-link" type="button" onClick={() => setShowTerms(true)}>
            Terms and Conditions of Service
          </button>
        </p>
      </div>

      {showTerms && <TermsOfService onClose={() => setShowTerms(false)} />}

      <style>{`
        .auth-terms {
          margin-top: 16px;
          font-size: 12px;
          color: #888;
          text-align: center;
        }
        .auth-terms-link {
          background: none;
          border: none;
          padding: 0;
          color: #4a90d9;
          font-size: 12px;
          cursor: pointer;
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}

export default Login;
